export default "__VITE_ASSET__FACwKlt5__"